import React, { useState, useEffect } from 'react';
import NotificationPopup from './NotificationPopup';
import NotificationMarquee from './NotificationMarquee';
import { useNotifications } from '../../Utils/useNotifications';

const NotificationManager = ({ pageName = 'dashboard' }) => {
  const {
    popupNotifications,
    marqueeNotifications,
    markNotificationAsShown,
    loading,
    error
  } = useNotifications(pageName);

  const [currentPopup, setCurrentPopup] = useState(null);
  const [currentMarquee, setCurrentMarquee] = useState(null);

  // Handle popup display (show only one at a time)
  useEffect(() => {
    if (popupNotifications.length > 0 && !currentPopup) {
      setCurrentPopup(popupNotifications[0]);
    }
  }, [popupNotifications, currentPopup]);

  // Handle marquee display (show only one at a time)
  useEffect(() => {
    if (marqueeNotifications.length > 0 && !currentMarquee) {
      setCurrentMarquee(marqueeNotifications[0]);
    }
  }, [marqueeNotifications, currentMarquee]);

  const handlePopupClose = () => {
    if (currentPopup) {
      markNotificationAsShown(currentPopup);
      setCurrentPopup(null);
      
      // Show next popup if available
      const remainingPopups = popupNotifications.filter(
        n => (n.id || n._id) !== (currentPopup.id || currentPopup._id)
      );
      if (remainingPopups.length > 0) {
        setTimeout(() => {
          setCurrentPopup(remainingPopups[0]);
        }, 500);
      }
    }
  };

  const handleMarqueeClose = () => {
    if (currentMarquee) {
      markNotificationAsShown(currentMarquee);
      setCurrentMarquee(null);
      
      // Show next marquee if available
      const remainingMarquees = marqueeNotifications.filter(
        n => (n.id || n._id) !== (currentMarquee.id || currentMarquee._id)
      );
      if (remainingMarquees.length > 0) {
        setTimeout(() => {
          setCurrentMarquee(remainingMarquees[0]);
        }, 500);
      }
    }
  };

  if (loading || error) {
    return null;
  }

  return (
    <>
      {/* Marquee notifications */}
      {currentMarquee && (
        <NotificationMarquee
          notification={currentMarquee}
        />
      )}

      {/* Popup notifications */}
      {currentPopup && (
        <NotificationPopup
          notification={currentPopup}
          onClose={handlePopupClose}
        />
      )}
    </>
  );
};

export default NotificationManager;